module.exports = __webpack_public_path__ + "images/marker-medisch.241bd5.png";